<template>
        <div class="flex flex-col rounded-2xl p-4 bg-white border border-gray-500 max-w-[20.8rem] min-w-[250px]">
            <div>
                <h1 class="text-primary font-bold text-center">Filtros</h1>
                <div class="flex flex-col gap-y-4">
                    <div class="flex flex-col gap-y-2">
                        <p class="font-bold">
                            Período
                        </p>
                        <div class="flex flex-wrap gap-y-1 w-full">
                            <a
                                href="javascript:void(0)"
                                class="border text-left p-2 px-4 text-black rounded-2xl border-gray-500 hover:bg-gray-300 hover:border-gray-300 transition-all cursor-pointer"
                                @click="openCalendar"
                                >
                                <span
                                    v-if="initialData.formatedData && finalData.formatedData"
                                    >{{
                                        `De ${formatInputPeriodDate(initialData.formatedData)} até ${formatInputPeriodDate(finalData.formatedData)}`
                                    }}</span>
                                <span v-else>
                                    Selecionar Período
                                </span>
                            </a>
                        </div>
                    </div>
                    <div
                        class="flex flex-col gap-y-1 max-h-[50vh] overflow-y-scroll no-scroll-bar"
                    >
                        <ExpandableRadio
                            :options="regions"
                            title="Regional"
                            placeholder="Selecione uma região"
                            class="w-full"
                            @updateValue="formFilter.region = $event"
                            :modelValue="formFilter.region"
                        />
                    </div>
                    <div
                        class="flex flex-col gap-y-6 max-h-[50vh] overflow-y-scroll no-scroll-bar"
                    >
                        <ExpandableRadio
                            :options="[
                                { value: 'N', name: 'Não iniciada' },
                                { value: 'E', name: 'Em andamento' },
                                { value: 'C', name: 'Finalizada' },
                            ]"
                            title="Status"
                            placeholder="Selecione um tipo de status"
                            class="w-full"
                            @updateValue="formFilter.votingStatus = $event"
                            :modelValue="formFilter.votingStatus"
                        />
                    </div>

                    <div
                        class="flex flex-col gap-y-1 max-h-[50vh] overflow-y-scroll no-scroll-bar"
                    >
                        <SearchableExpandableRadio
                            :options="computedContestUniqueNames"
                            title="Campanha"
                            placeholder="Selecione uma campanha"
                            class="w-full"
                            @updateValue="formFilter.campaign = $event.value"
                            :modelValue="formFilter.campaign"
                        />
                    </div>

                    <div class="flex flex-col items-center">
                        <div>
                            <Button
                                @click.prevent="sendSpecificFilter"
                                class="bg-primary !text-white p-4"
                            >
                                Aplicar Filtros
                            </Button>
                        </div>
                        <div>
                            <a
                                @click="cleanFilter"
                                class="text-primary text-xs hover:underline cursor-pointer"
                            >
                                Limpar Filtros
                            </a>
                        </div>
                    </div>
                </div>

                <transition v-if="showCalendar">
                    <div class="grid modal-show fixed bg-gray-600 bg-opacity-80 top-0 left-0 items-center justify-center w-screen h-screen z-20">
                        <div class="bg-white max-w-[300px] p-4 rounded-2xl">
                            <div class="relative">
                                <h1 class="font-bold text-primary text-center">Filtro</h1>
                                <a
                                    href="javascript:void(0) "
                                    class="absolute top-0 left-0 text-blue-500 hover:underline text-xs"
                                    @click="closeCalendar"
                                >
                                    Voltar
                                </a>
                                <Icon
                                    name="Fechar"
                                    class="absolute top-0 right-0 text-blue-500 hover:underline text-xs cursor-pointer"
                                    @click="closeCalendar"
                                >
                                    Icon
                                </Icon>
                            </div>
                            <p class="text-gray-500 font-bold mt-1">Data</p>
                            <ul class="grid gap-5 mt-1 grid-flow-col">
                                <li>
                                    <label class="mb-1 mr-5 flex font-semibold">
                                        De:
                                    </label>
                                    <input
                                        @click="setInput('initialData')"
                                        v-model="initialData.data"
                                        @keyup="formatDate"
                                        type="text"
                                        placeholder="DD/MM/AAAA"
                                        class="form-input border rounded-2xl w-full focus:border-primary disabled:opacity-50 bg-gray-100 border-gray-300"
                                    />
                                </li>

                                <li>
                                    <label class="mb-1 mr-5 flex font-semibold">
                                        Até:
                                    </label>
                                    <input
                                        @click="setInput('finalData')"
                                        v-model="finalData.data"
                                        @keyup="formatDate"
                                        type="text"
                                        placeholder="DD/MM/AAAA"
                                        class="form-input border rounded-2xl w-full focus:border-primary disabled:opacity-50 bg-gray-100 border-300"
                                    />
                                </li>
                            </ul>

                            <div class="calendar bg-gray-100 p-4 mt-8 rounded-2xl">
                                <div
                                    class="flex justify-between"
                                >
                                    <Icon @click="prev" name="ArrowWithoutCircle" class="rotate-180 cursor-pointer" />
                                    <span class="font-bold text-primary text-center">{{
                                        title
                                    }}</span>
                                    <Icon @click="next" name="ArrowWithoutCircle" class="cursor-pointer" />
                                </div>

                                <div
                                    class="week grid grid-flow-col justify-items-center pt-2 pb-2"
                                >
                                    <div class="day text-xs uppercase">Dom</div>
                                    <div class="day text-xs uppercase">Seg</div>
                                    <div class="day text-xs uppercase">Ter</div>
                                    <div class="day text-xs uppercase">Qua</div>
                                    <div class="day text-xs uppercase">Qui</div>
                                    <div class="day text-xs uppercase">Sex</div>
                                    <div class="day text-xs uppercase">Sab</div>
                                </div>

                                <div
                                    class="week grid grid-cols-auto-calendar justify-items-center h-8 items-center text-sm"
                                    v-for="(week, key) in weeks"
                                    :key="key"
                                >
                                    <!-- :class="day == '0' ? 'hide' : ''" -->
                                    <div
                                        class="day selectable g cursor-pointer hover:bg-primary hover:text-white rounded-full p-2 py-1.5 min-w-[32px] text-center"
                                        :class="{ hide: isZero(day) }"
                                        v-for="(day, key) in week"
                                        :key="key"
                                        @click="setData(day, month, year, $event)"
                                    >
                                        {{ day }}
                                    </div>
                                </div>
                            </div>

                            <div class="grid justify-items-center mt-8">
                                <a
                                    @click="saveSpecificFilter()"
                                    href="javascript:void(0)"
                                    class="font-semibold grid p-4 leading-normal bg-primary text-white rounded-2xl"
                                    >Selecionar Datas</a
                                >
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
</template>

<script>
import moment from "moment";
import { Head } from "@inertiajs/inertia-vue3";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import { formatUpdatedDate, formatDate } from "@/Helpers/masks";
import ExpandableRadio from "@/Components/ExpandableRadio.vue";
import ExpandableCheckbox from "@/Components/ExpandableCheckbox.vue";
import Input from "@/Components/UI/Form/Input.vue";
import SearchableExpandableRadio from "../SearchableExpandableRadio.vue";

const DATE = new Date();
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
];
const daysInYearMonth = (y, m) => new Date(y, m + 1, 0).getDate();

export default {
    components: {
    Head,
    Head,
    Icon,
    Button,
    ExpandableRadio,
    ExpandableCheckbox,
    Input,
    SearchableExpandableRadio
},

    computed: {
        computedContest() {
            return this.campaigns.map((contest) => ({
                ...contest,
                name: this.handleName(contest),
                id: contest.id,
            }));
        },
        computedContestUniqueNames() {
            return this.campaigns.reduce((acc, curr) => {
                if(acc.some(el => el.name === curr.name) == false) {
                    acc.push({
                        value: curr.name,
                        name: curr.name
                    });
                }

                return acc
            } ,[]);
        }
    },

    props: {
        campaigns: Object,
        regions: Object,
    },

    emits: ["updateFilter"],

    data() {
        return {
            currentGallery: "",
            showModalChangePoints: false,
            title: "-",
            month: 0,
            year: 0,
            days: [],
            weeks: [],
            filterLessDay: "",
            initialData: {
                data: "",
                elSelected: "",
                formatedData: "",
            },
            finalData: {
                data: "",
                elSelected: "",
                formatedData: "",
            },
            currentInput: "",
            isAddClassPeriodoData: false,
            isAddClassPeriodoCalendar: false,
            showSelectRegions: false,
            formFilter: this.$inertia.form({
                campaign: "",
                region: "",
                votingStatus: "",
            }),
            showCalendar: false,
        };
    },

    mounted() {
        this.init();
    },

    methods: {
        handleName(contest) {
            if (contest.name.toLowerCase() === "nespoints")
                return `${contest.name} (${moment(contest.startDate)
                    .locale("pt-br")
                    .format("MMM")
                    .toUpperCase()} à ${moment(contest.endDate)
                    .locale("pt-br")
                    .format("MMM")
                    .toUpperCase()})`;
            return contest.name;
        },
        resetSetDate() {
            this.isAddClassPeriodoData = true;
            this.filterLessDay = "";

            if (this.initialData.elSelected) {
                this.initialData.elSelected?.classList.remove("bg-primary");
                this.initialData.elSelected?.classList.remove("text-white");
            }
            if (this.finalData.elSelected) {
                this.finalData.elSelected?.classList.remove("bg-primary");
                this.finalData.elSelected?.classList.remove("text-white");
            }

            this.initialData.data = "";
            this.initialData.elSelected = "";
            this.finalData.data = "";
            this.finalData.elSelected = "";
        },
        isZero(value) {
            if (value == 0) {
                return true;
            }
        },
        getData(day, month, year) {
            if (day < 10) {
                day = `0${day.toString()}`;
            }
            if (month + 1 < 10) {
                month = `0${(month + 1).toString()}`;
            } else {
                month = month + 1;
            }
            return `${day}${month}${year}`;
        },

        setInput(input) {
            this.currentInput = input;
        },

        setData(day, month, year, el) {
            let data = this.formatData(this.getData(day, month, year));

            if (this.currentInput == "initialData") {
                if (this.initialData.elSelected) {
                    this.initialData.elSelected.classList.remove("bg-primary");
                    this.initialData.elSelected.classList.remove("text-white");
                }
                this.initialData.elSelected = el.target;
                this.initialData.elSelected.classList.add("bg-primary");
                this.initialData.elSelected.classList.add("text-white");

                this.initialData.data = data;
            }
            if (this.currentInput == "finalData") {
                if (this.finalData.elSelected) {
                    this.finalData.elSelected.classList.remove("bg-primary");
                    this.finalData.elSelected.classList.remove("text-white");
                }
                this.finalData.elSelected = el.target;
                this.finalData.elSelected.classList.add("bg-primary");
                this.finalData.elSelected.classList.add("text-white");

                this.finalData.data = data;
            }
        },

        formatData(data) {
            let value = data;

            value = value.replace(/\D/g, "");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");
            value = value.replace(/(\d{2})(\d)/, "$1/$2");

            value = value.replace(/(\d{2})(\d{2})$/, "$1$2");

            return value.substr(0, 10);
        },

        next() {
            this.update(new Date(this.year, this.month + 1, 1));
        },
        prev() {
            this.update(new Date(this.year, this.month - 1, 1));
        },
        daysInMonth() {
            return daysInYearMonth(this.year, this.month);
        },
        monthStartsOn() {
            return new Date(this.year, this.month, 1).getDay();
        },
        setTitle() {
            this.title = `${MONTHS[this.month]} ${this.year}`;
        },
        update(date) {
            if (date) {
                this.month = date.getMonth();
                this.year = date.getFullYear();
                this.day = date.getDate();
            }
            this.setTitle();
            this.setDays();
            this.setWeeks();
        },
        setDays() {
            let preDays =
                this.monthStartsOn() > 0
                    ? Array(this.monthStartsOn()).fill(0)
                    : [];
            const rawDays = [...Array(this.daysInMonth()).keys()];
            this.days = [...preDays, ...rawDays.map((item) => item + 1)];
        },
        setWeeks() {
            let n = 0;
            this.weeks = [];

            while (n < this.days.length) {
                let week = [
                    ...this.days.slice(n, (n += 7)),
                    ...Array(7).fill(0),
                ].slice(0, 7);
                this.weeks.push(week);
            }
        },
        showEvents(day) {
            alert(day);
        },
        init() {
            this.update(DATE);
        },
        formatUpdatedDate,
        formatDate,
        formatFilterDate(data) {
            let dia = data.getDate();
            let mes = data.getMonth();
            let ano = data.getFullYear();

            return `${ano}-${mes + 1}-${dia}`;
        },
        saveSpecificFilter() {
            let initialArrayData = this.initialData.data.split("/");
            let objectInitialData = new Date(
                initialArrayData[2],
                initialArrayData[1] - 1,
                initialArrayData[0]
            );

            let finalArrayData = this.finalData.data.split("/");
            let objectFinalData = new Date(
                finalArrayData[2],
                finalArrayData[1] - 1,
                finalArrayData[0]
            );

            if (
                this.checarData(objectInitialData) &&
                this.checarData(objectFinalData)
            ) {
                let initialDateFormated =
                    this.formatFilterDate(objectInitialData);
                let finalDataFormated = this.formatFilterDate(objectFinalData);

                this.initialData.formatedData = initialDateFormated;
                this.finalData.formatedData = finalDataFormated;
            } else {
                this.initialData.formatedData = undefined;
                this.finalData.formatedData = undefined;
            }

            this.closeCalendar();
        },
        sendSpecificFilter() {
            this.$emit("updateFilter", {
                startDate: this.initialData.formatedData,
                endDate: this.finalData.formatedData,
                name: this.formFilter.campaign,
                votingStatus: this.formFilter.votingStatus.value,
                region: this.formFilter.region.value,
            });
        },
        checarData(data) {
            return data instanceof Date && !isNaN(data);
        },
        loadContest(contest) {
            axios
                .get(`/contest/${contest.id}`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.categories = data?.categories.map((item) => ({
                        name: item.description,
                        id: item.id,
                    }));
                    this.executions = data?.executionTypes.map((item) => ({
                        name: item.description,
                        id: item.id,
                        weight: item.weight,
                    }));
                });
        },
        loadPdv(pdv) {
            axios
                .get(`/pdv/${pdv.id}/users`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.form.team = [];
                    this.users = data;

                    for (let i = 0; i < Object.keys(this.$refs).length; i++) {
                        if (this.$refs[`checkbox-` + i]) {
                            this.$refs[`checkbox-` + i].checked = false;
                        }
                    }
                });
        },
        formatInputPeriodDate(date) {
            return moment(date).format("DD/MM")
        },
        openCalendar() {
            this.showCalendar = true;
        },
        closeCalendar() {
            this.showCalendar = false;
        },
        cleanFilter() {
            this.formFilter = this.$inertia.form({
                campaign: "",
                region: "",
                votingStatus: "",
            });

            this.initialData = {
                data: "",
                elSelected: "",
                formatedData: "",
            };

            this.finalData = {
                data: "",
                elSelected: "",
                formatedData: "",
            };
        }
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scroll-bar::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scroll-bar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
</style>
